import React from 'react';
import { Box, CssBaseline } from '@mui/material';
import Navbar from './Navbar';
import BottomNavigation from '../ui/BottomNavigation';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <CssBaseline />
      <Navbar />
      <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', pb: { xs: '80px', sm: 0 } }}>
        {children}
      </Box>
      <BottomNavigation />
    </Box>
  );
};

export default Layout;